module.exports = __webpack_public_path__ + "img/img_intro_2_deco2.b236a5a7.gif";